import { useEffect, useRef } from 'react'

interface UseInfiniteScrollOptions {
  loadMore?: () => void
  hasNextPage?: boolean
  threshold?: number
}

export const useInfiniteScroll = ({
  loadMore,
  hasNextPage,
  threshold = 0.1
}: UseInfiniteScrollOptions) => {
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!ref.current || !hasNextPage || !loadMore) return

    const observer = new IntersectionObserver(
      (entries) => {
        if (entries[0].isIntersecting && hasNextPage) {
          loadMore()
        }
      },
      { threshold }
    )

    observer.observe(ref.current)

    return () => observer.disconnect()
  }, [hasNextPage, loadMore, threshold])

  return ref
}
